var _unique = function _unique(definitions) {
  var names = {};
  return definitions.filter(function (definition) {
    if (definition.kind !== 'FragmentDefinition') {
      return true;
    }

    var name = definition.name.value;

    if (names[name]) {
      return false;
    } else {
      names[name] = true;
      return true;
    }
  });
};

import USER_DATA from '../fragments/userData';
var REMOVE_CAMPER_TRIP_FROM_CART = {
  "kind": "Document",
  "definitions": _unique([{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "removeCamperTripFromCart"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "uuid"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      },
      "directives": []
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "tripId"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "Int"
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "removeCamperTripFromCart"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "uuid"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "uuid"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "tripId"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "tripId"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "UserData"
            },
            "directives": []
          }]
        }
      }]
    }
  }].concat(USER_DATA.definitions)),
  "loc": {
    "start": 0,
    "end": 182,
    "source": {
      "body": "\n    \n    mutation removeCamperTripFromCart($uuid: String!, $tripId: Int!) {\n        removeCamperTripFromCart(uuid: $uuid, tripId: $tripId) {\n            ...UserData\n        }\n    }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
export default REMOVE_CAMPER_TRIP_FROM_CART;